export default __webpack_public_path__ + "static/compareItemImg5-bd471e48ff65eb5abd853709331f1572.png";